<button
  (click)="goToMainContent()"
  class="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-9999 focus:px-4 focus:py-2 focus:rounded focus:bg-primary focus:text-on-primary focus:font-semibold"
>
  Vai al contenuto principale
</button>
<!-- 24px: altezza di siat-header (standard-height in override.scss) -->
<div class="flex bg-(--mat-sys-surface) h-[calc(100vh-24px)] overflow-hidden">
  <aside
    aria-label="Menu di navigazione principale"
    [ngClass]="isCollapsed ? 'w-27.5' : 'w-70'"
    class="flex flex-col transition-all duration-300 ease-in-out shrink-0"
  >
    <div
      class="flex items-center h-16 w-full"
      [ngClass]="isCollapsed ? 'justify-center' : 'justify-end'"
    >
      <button
        mat-icon-button
        [attr.aria-label]="isCollapsed ? 'Espandi menu' : 'Comprimi menu'"
        (click)="toggleSidebar.emit()"
      >
        <mat-icon [fontIcon]="isCollapsed ? 'menu' : 'menu_open'"></mat-icon>
      </button>
    </div>

    <nav
      class="flex flex-col items-center w-full px-2 gap-4 overflow-y-auto pt-4"
    >
      @if (currentAppMenuItems$ | async; as menuItems) {
        <div class="flex flex-col items-center w-full gap-4 mb-4">
          @for (item of menuItems; track trackByFn($index, item)) {
            @if (item.isSpecialAction && (isStrutturaType$ | async)) {
              <div
                class="flex flex-col items-center w-full"
                [ngClass]="isCollapsed ? 'justify-center' : 'justify-start'"
              >
                <button
                  mat-fab
                  class="special-action-fab"
                  [attr.aria-label]="item.title | translate"
                  [matTooltip]="item.title | translate"
                  (click)="onPrimaryNavItemClicked(item)"
                >
                  <mat-icon
                    class="text-white!"
                    [fontIcon]="item.icon"
                  ></mat-icon>
                </button>
                @if (!isCollapsed) {
                  <span
                    class="text-sm font-normal tracking-tight pt-2 text-on-secondary-container flex-1 text-left"
                  >
                    {{ item.title | translate }}
                  </span>
                }
              </div>
            }
          }
        </div>

        <div class="flex flex-col items-center w-full gap-1">
          @for (item of menuItems; track trackByFn($index, item)) {
            @if (!item.isSpecialAction) {
              <div class="w-full">
                <siat-sidenav-menu-item
                  [isCollapsed]="isCollapsed"
                  [item]="item"
                  (itemClicked)="onPrimaryNavItemClicked($event)"
                ></siat-sidenav-menu-item>
              </div>
            }
          }
        </div>
      }
    </nav>
  </aside>

  <main class="grow relative overflow-hidden h-full">
    <mat-sidenav-container class="h-full bg-transparent!">
      <mat-sidenav
        #secondarySidenav
        mode="side"
        class="secondary-sidenav w-50 border-r"
        style="border-left: 1px solid var(--mat-sys-outline-variant)"
      >
        <mat-nav-list>
          @for (child of selectedMenu?.subItems; track child.href) {
            <a
              mat-list-item
              [routerLink]="child.href"
              routerLinkActive="active-sub-item"
              [routerLinkActiveOptions]="{ exact: true }"
              (click)="secondarySidenav.close()"
            >
              <span matListItemTitle>{{ child.title | translate }}</span>
            </a>
          }
        </mat-nav-list>
      </mat-sidenav>

      <mat-sidenav-content class="relative flex! flex-col! w-full!">
        <div
          class="md:container-xl p-4 flex-1!"
          id="main-content"
          #mainContent
          tabindex="-1"
        >
          <ng-content></ng-content>
        </div>
        <div class="mt-auto">
          <siat-footer></siat-footer>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </main>
</div>
